module.exports = __webpack_public_path__ + "img/bj_zanwu@2x.6aa57a66.png";